import  {getRequest,postRequest,post}  from "@/utils/axios";
//领取优惠卷
export const clainCoupon = data => postRequest(`/coupon/couponClaimLog/clainCoupon`, data)
//领取优惠卷
export const getCanvasInfo = data => getRequest(`/coupon/couponCompanyCanvasType/getCanvasInfo`, data)
//领取优惠卷
export const getClaimCoupon = data => postRequest(`/coupon/couponClaimLog/claimCoupon`, data)